/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSymphonyImportErrorsDto
 */
export interface GetSymphonyImportErrorsDto {
    /**
     * 
     * @type {number}
     * @memberof GetSymphonyImportErrorsDto
     */
    tbInvoiceId: number;
    /**
     * 
     * @type {number}
     * @memberof GetSymphonyImportErrorsDto
     */
    clientSystemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetSymphonyImportErrorsDto
     */
    salesInvoiceId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetSymphonyImportErrorsDto
     */
    salesInvoiceSystemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetSymphonyImportErrorsDto
     */
    salesInvoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetSymphonyImportErrorsDto
     */
    salesInvoiceCorrectedNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSymphonyImportErrorsDto
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof GetSymphonyImportErrorsDto
     */
    symphonyNumberCodes: string;
    /**
     * 
     * @type {string}
     * @memberof GetSymphonyImportErrorsDto
     */
    importErrors?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSymphonyImportErrorsDto
     */
    modificationDate?: Date | null;
}

/**
 * Check if a given object implements the GetSymphonyImportErrorsDto interface.
 */
export function instanceOfGetSymphonyImportErrorsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tbInvoiceId" in value;
    isInstance = isInstance && "clientSystemNumber" in value;
    isInstance = isInstance && "salesInvoiceSystemNumber" in value;
    isInstance = isInstance && "salesInvoiceNumber" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "symphonyNumberCodes" in value;

    return isInstance;
}

export function GetSymphonyImportErrorsDtoFromJSON(json: any): GetSymphonyImportErrorsDto {
    return GetSymphonyImportErrorsDtoFromJSONTyped(json, false);
}

export function GetSymphonyImportErrorsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSymphonyImportErrorsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tbInvoiceId': json['tbInvoiceId'],
        'clientSystemNumber': json['clientSystemNumber'],
        'salesInvoiceId': !exists(json, 'salesInvoiceId') ? undefined : json['salesInvoiceId'],
        'salesInvoiceSystemNumber': json['salesInvoiceSystemNumber'],
        'salesInvoiceNumber': json['salesInvoiceNumber'],
        'salesInvoiceCorrectedNumber': !exists(json, 'salesInvoiceCorrectedNumber') ? undefined : json['salesInvoiceCorrectedNumber'],
        'currency': json['currency'],
        'symphonyNumberCodes': json['symphonyNumberCodes'],
        'importErrors': !exists(json, 'importErrors') ? undefined : json['importErrors'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
    };
}

export function GetSymphonyImportErrorsDtoToJSON(value?: GetSymphonyImportErrorsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tbInvoiceId': value.tbInvoiceId,
        'clientSystemNumber': value.clientSystemNumber,
        'salesInvoiceId': value.salesInvoiceId,
        'salesInvoiceSystemNumber': value.salesInvoiceSystemNumber,
        'salesInvoiceNumber': value.salesInvoiceNumber,
        'salesInvoiceCorrectedNumber': value.salesInvoiceCorrectedNumber,
        'currency': value.currency,
        'symphonyNumberCodes': value.symphonyNumberCodes,
        'importErrors': value.importErrors,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
    };
}

